import styled from 'styled-components';

export const RoleAssumptionContainerStyle = styled.div`
    margin-top: 42px;
`;
